// Builds a `mailto:` href with an encoded subject and body. Falsy entries in `lines` are dropped
// before joining — callers pass `condition && "Label: value"` for context that isn't always known.
export const buildMailto = (
  to: string,
  subject: string,
  lines: Array<string | false | undefined | null>,
): string => {
  const body = lines.filter(Boolean).join('\n');
  return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
